import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "opportunity-form",
  class: "salesforce-opportunity-form"
}
const _hoisted_2 = { class: "form-toolbar" }
const _hoisted_3 = { class: "form-cards-container" }
const _hoisted_4 = { class: "card-grid" }
const _hoisted_5 = { class: "field-group full-width" }
const _hoisted_6 = { class: "card-grid" }
const _hoisted_7 = { class: "field-group" }
const _hoisted_8 = { class: "field-group" }
const _hoisted_9 = { class: "field-group" }
const _hoisted_10 = { class: "field-group" }
const _hoisted_11 = { class: "field-group full-width" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolbarForm = _resolveComponent("ToolbarForm")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxTextArea = _resolveComponent("DxTextArea")!
  const _component_DxNumberBox = _resolveComponent("DxNumberBox")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxDropDownBox = _resolveComponent("DxDropDownBox")!
  const _component_DxSelectBox = _resolveComponent("DxSelectBox")!
  const _component_DxDateBox = _resolveComponent("DxDateBox")!
  const _component_DxValidationGroup = _resolveComponent("DxValidationGroup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxValidationGroup, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ToolbarForm, {
            "is-editing": _ctx.isEditing,
            "is-disabled": _ctx.isLocked,
            "allow-edit": _ctx.allowEdit,
            onEditCanceled: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancelEdit())),
            onEditToggled: _cache[1] || (_cache[1] = ($event: any) => (_ctx.startEdit())),
            onSaveClicked: _ctx.handleSaveClick
          }, null, 8, ["is-editing", "is-disabled", "allow-edit", "onSaveClicked"])
        ]),
        _createVNode(_component_DxLoadPanel, {
          "show-pane": false,
          width: "auto",
          container: "#opportunity-form",
          position: { of: '#opportunity-form' },
          visible: _ctx.isLoading
        }, null, 8, ["visible"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.general }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleSection('general')))
            }, [
              _cache[14] || (_cache[14] = _createElementVNode("i", { class: "dx-icon-info" }, null, -1)),
              _cache[15] || (_cache[15] = _createElementVNode("h3", null, "Informații Generale", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.general ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[16] || (_cache[16] = _createElementVNode("label", { class: "field-label" }, "Observații", -1)),
                _createVNode(_component_DxTextArea, {
                  value: _ctx.opportunityData.Note,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.opportunityData.Note) = $event)),
                  "read-only": !_ctx.isEditing,
                  height: 100
                }, null, 8, ["value", "read-only"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.general]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["info-card", { 'collapsed': !_ctx.expandedSections.financial }])
          }, [
            _createElementVNode("div", {
              class: "card-section-header",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleSection('financial')))
            }, [
              _cache[17] || (_cache[17] = _createElementVNode("i", { class: "dx-icon-money" }, null, -1)),
              _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Achiziție", -1)),
              _createElementVNode("i", {
                class: _normalizeClass(["expand-icon", _ctx.expandedSections.financial ? 'dx-icon-chevrondown' : 'dx-icon-chevronright'])
              }, null, 2)
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[19] || (_cache[19] = _createElementVNode("label", { class: "field-label" }, "Buget Estimat", -1)),
                _createVNode(_component_DxNumberBox, {
                  modelValue: _ctx.opportunityData.BugetEstimat,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.opportunityData.BugetEstimat) = $event)),
                  "read-only": !_ctx.isEditing,
                  format: _ctx.budgetFormat,
                  showSpinButtons: false,
                  width: "100%"
                }, null, 8, ["modelValue", "read-only", "format"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[20] || (_cache[20] = _createElementVNode("label", { class: "field-label" }, "Valută", -1)),
                _createVNode(_component_DxDropDownBox, {
                  opened: _ctx.isValutaGridBoxOpened,
                  "onUpdate:opened": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isValutaGridBoxOpened) = $event)),
                  modelValue: _ctx.opportunityData.ValutaID,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.opportunityData.ValutaID) = $event)),
                  "data-source": _ctx.dsValute,
                  value: _ctx.sValuta,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.sValuta) = $event)),
                  "show-clear-button": true,
                  "display-expr": "Simbol",
                  "value-expr": "Id",
                  "read-only": !_ctx.isEditing
                }, {
                  content: _withCtx(({ data }) => [
                    _createVNode(_component_DxDataGrid, {
                      "data-source": _ctx.dsValute,
                      value: _ctx.sValuta,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sValuta) = $event)),
                      columns: ['Simbol'],
                      "hover-state-enabled": true,
                      height: "100%",
                      onSelectionChanged: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onValueSelectedValuta($event)))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DxSelection, { mode: "single" }),
                        _createVNode(_component_DxPaging, {
                          enabled: true,
                          "page-size": 5
                        }),
                        _createVNode(_component_DxFilterRow, { visible: true }),
                        _createVNode(_component_DxSearchPanel, {
                          visible: true,
                          placeholder: "Cauta ..."
                        })
                      ]),
                      _: 1
                    }, 8, ["data-source", "value"])
                  ]),
                  _: 1
                }, 8, ["opened", "modelValue", "data-source", "value", "read-only"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "field-label" }, "Interval Cumparare", -1)),
                _createVNode(_component_DxSelectBox, {
                  modelValue: _ctx.opportunityData.IntervalCumparare,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.opportunityData.IntervalCumparare) = $event)),
                  "data-source": _ctx.intervalList,
                  "display-expr": "name",
                  "value-expr": "name",
                  "read-only": !_ctx.isEditing,
                  "show-clear-button": true,
                  "search-enabled": true,
                  placeholder: "Necunoscut"
                }, null, 8, ["modelValue", "data-source", "read-only"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[22] || (_cache[22] = _createElementVNode("label", { class: "field-label" }, "Data Închidere Estimat", -1)),
                _createVNode(_component_DxDateBox, {
                  modelValue: _ctx.opportunityData.DataInchidereEstimat,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.opportunityData.DataInchidereEstimat) = $event)),
                  type: "date",
                  "display-format": "dd.MM.yyyy",
                  "read-only": !_ctx.isEditing
                }, null, 8, ["modelValue", "read-only"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "field-label" }, "Campanie", -1)),
                _createVNode(_component_DxSelectBox, {
                  modelValue: _ctx.opportunityData.CampanieID,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.opportunityData.CampanieID) = $event)),
                  "data-source": _ctx.campanii,
                  "display-expr": "Denumire",
                  "value-expr": "ID",
                  "search-enabled": true,
                  "read-only": !_ctx.isEditing
                }, null, 8, ["modelValue", "data-source", "read-only"])
              ])
            ], 512), [
              [_vShow, _ctx.expandedSections.financial]
            ])
          ], 2)
        ])
      ]),
      _: 1
    })
  ]))
}